export default "__VITE_ASSET__a53dce59__"